import { Flex } from "@aws-amplify/ui-react";
import {
  convertSelectValueToInputValue,
  keisokuCycleSettingJson,
} from '../../../lib/SettingUtil';

import {
  SetteiItemCycleWrapper,
} from '../../../componentsWrapper';

const MeasurementCycleSetting = ({
  editSettingJson,
  setEditSettingJson,
}) => {

  return (
    <>
      <Flex direction="column">
        {editSettingJson !== null &&
          Object.entries(keisokuCycleSettingJson).map((item, index) => (
            <>
              <SetteiItemCycleWrapper
                key={index}
                labeltext={item[1].labeltext}
                cyclevalue1={editSettingJson[item[0]]["1st"] !== null ? "アンテナ" + editSettingJson[item[0]]["1st"] : "なし"}
                cyclevalue1OnChangeHandler={(e) => {
                  console.log(e.target.value);
                  console.log(convertSelectValueToInputValue(item[0], e.target.value));
                  setEditSettingJson({
                    ...editSettingJson,
                    [item[0]]: {
                      ...editSettingJson[item[0]],
                      "1st": convertSelectValueToInputValue(item[0], e.target.value)
                    }
                  });
                }}
                cyclevalue2={editSettingJson[item[0]]["2nd"] !== null ? "アンテナ" + editSettingJson[item[0]]["2nd"] : "なし"}
                cyclevalue2OnChangeHandler={(e) => {
                  console.log(e.target.value);
                  console.log(convertSelectValueToInputValue(item[0], e.target.value));

                  let value = convertSelectValueToInputValue(item[0], e.target.value);

                  setEditSettingJson({
                    ...editSettingJson,
                    [item[0]]: {
                      ...editSettingJson[item[0]],
                      "2nd": value,
                      ...value == null && {
                        "3rd": null,
                      }
                    }
                  });
                }}
                cyclevalue3={editSettingJson[item[0]]["3rd"] !== null ? "アンテナ" + editSettingJson[item[0]]["3rd"] : "なし"}
                cyclevalue3OnChangeHandler={(e) => {
                  console.log(e.target.value);
                  console.log(convertSelectValueToInputValue(item[0], e.target.value));
                  setEditSettingJson({
                    ...editSettingJson,
                    [item[0]]: {
                      ...editSettingJson[item[0]],
                      "3rd": convertSelectValueToInputValue(item[0], e.target.value)
                    }
                  });
                }}
              >
              </SetteiItemCycleWrapper>
            </>
          ))}
      </Flex>
    </>
  );
};

export default MeasurementCycleSetting;